export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12943.e064fff7.jpg";